import Controller from "./bulkInvoiceItemTypesUpload.controller";
import template from "./bulkInvoiceItemTypesUpload.html";

const bulkInvoiceItemTypesUpload = {
  template,
  controller: Controller,
};

export default bulkInvoiceItemTypesUpload;



// WEBPACK FOOTER //
// ./src/pages/bulkInvoiceItemTypesUpload/bulkInvoiceItemTypesUpload.component.js